
<template>
    <div class="PHD">
        <div class="l-main">
            <div class="container">
                <div class="row">
                    <div class="col-12">
                        <h1 class="page-heading mb-3">PHD Media Block / Profile Card component examples</h1>
                    </div>
                </div>

                <!-- Begin: PHD Media Block / Profile Card component examples -->
                <div class="row">
                    <div class="col-12">
                        <h2 class="h2 mb-3">Media Block - All fields present</h2>
                    </div>
                </div>

                <div class="row">
                    <div class="col-12 col-lg-6 mb-4">
                        <!-- Begin: Media Block - all options -->
                        <!-- Dev Note(s): 
                            Note the addition of '.phd-shadow-box' on this item and it's friend in the next column.  This forces these to render as a standard shadow-box style card.  This class should be optional, depending on where it's used on the site and how it is desired to appear.
                        -->
                        <div class="media-block phd-shadow-box">
                            <div class="row media-block__first-row">
                                <div class="col-12 media-block__top">
                                    <!-- Begin: Optional Row - do not render if there is no content -->
                                    <div class="row">
                                        <div class="col-12 media-block__title">
                                            <h2 class="h2">Example title for this specific block</h2>
                                        </div>
                                    </div>
                                    <!-- End:   Optional Row - do not render if there is no content -->

                                    <div class="row">
                                        <div class="col-12 col-md-4 media-block__media-container">
                                            <!-- desired width here is 180px max, for mobile -->
                                            <img src="https://via.placeholder.com/180/440066/eeeeee" alt="placeholder image" class="img-fluid">
                                        </div>

                                        <div class="col-12 col-md-8 media-block__rich-container">
                                            <p>Rich text goes here.</p>
                                            
                                            <p>Deserunt est, repellat, debitis excepturi corrupti velit laudantium eveniet at, obcaecati amet neque ad doloremque quod et facilis eius? Esse, beatae voluptatem ab delectus eaque consequuntur commodi id reiciendis adipisci?</p>
                                            
                                            <p><a href="#">example link below first paragraph, still in rich text</a></p>
                                        </div>
                                    </div>
                                </div>

                                <!-- Begin: Optional block - do not render if there is no content -->
                                <div class="col-12 media-block__bottom">
                                    <a href="#" class="c-cta c-cta--arrow h-theme--red">Example bottom of block link</a>
                                </div>
                                <!-- End:   Optional block - do not render if there is no content -->
                            </div>
                        </div>
                        <!-- End:   Media Block - all options -->
                    </div>

                    <div class="col-12 col-lg-6 mb-4">
                        <!-- Begin: Media Block - all options -->
                        <div class="media-block phd-shadow-box">
                            <div class="row media-block__first-row">
                                <div class="col-12 media-block__top">
                                    <!-- Begin: Optional Row - do not render if there is no content -->
                                    <div class="row">
                                        <div class="col-12 media-block__title">
                                            <h2 class="h2">Example title for this specific block</h2>
                                        </div>
                                    </div>
                                    <!-- End:   Optional Row - do not render if there is no content -->

                                    <div class="row">
                                        <div class="col-12 col-md-4 media-block__media-container">
                                            <!-- desired width here is 180px max, for mobile -->
                                            <img src="https://via.placeholder.com/180/440066/eeeeee" alt="placeholder image" class="img-fluid">
                                        </div>

                                        <div class="col-12 col-md-8 media-block__rich-container">
                                            <p>Rich text goes here.</p>
                                            
                                            <p>Lorem ipsum dolor sit amet consectetur adipisicing elit. Repellendus deleniti id quisquam, minima eligendi asperiores recusandae laboriosam reiciendis necessitatibus magni doloremque numquam ipsum iusto ea non nemo facere cum laborum.</p>

                                            <p>Fugiat harum voluptates sequi id temporibus reiciendis mollitia officia? Error excepturi quidem pariatur earum dolor distinctio assumenda facilis, unde iure officia sint reprehenderit nulla qui quo voluptas atque molestias architecto.</p>
                                            
                                            <p><a href="#">example link below first paragraph, still in rich text</a></p>
                                        </div>
                                    </div>
                                </div>

                                <!-- Begin: Optional block - do not render if there is no content -->
                                <div class="col-12 media-block__bottom">
                                    <a href="#" class="c-cta c-cta--arrow h-theme--red">Example bottom of block link</a>
                                </div>
                                <!-- End:   Optional block - do not render if there is no content -->
                            </div>
                        </div>
                        <!-- End:   Media Block - all options -->
                    </div>
                </div>

                <!-- Begin: Media Block - only required fields -->
                <div class="row">
                    <div class="col-12">
                        <h2 class="h2 mt-5 mb-3">Media Block(s) - no optional fields present</h2>
                    </div>
                </div>

                <div class="row">
                    <div class="col-12 col-lg-8 mb-4">
                        <!-- Dev Note(s): 
                            Note the use of the 'phd-shadow-box' class on a wrapping <div> here, rather than on the 'media-block' item itself... this is because the desired result is to have a stack of media-block items inside of a shadow-box card, rather than having the card itself be a shadow-box.
                        -->
                        <div class="phd-shadow-box">
                            <h2 class="mb-3">Stacked example of minimal content media items</h2>

                            <div class="row">
                                <div class="col-12 my-2">
                                    <div class="media-block">
                                        <div class="row media-block__first-row">
                                            <div class="col-12 media-block__top">
                                                <div class="row">
                                                    <div class="col-12 col-md-4 media-block__media-container">
                                                        <!-- desired width here is 180px max, for mobile -->
                                                        <img src="https://via.placeholder.com/180/440066/eeeeee" alt="placeholder image">
                                                    </div>

                                                    <div class="col-12 col-md-8 media-block__rich-container">
                                                        <p>Lorem ipsum dolor sit amet consectetur adipisicing elit. Repudiandae perferendis non necessitatibus. Voluptatibus adipisci iure, hic velit qui a sed est nesciunt laborum inventore cupiditate porro aliquid. Vel, voluptatibus nihil.</p>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>

                            <div class="row">
                                <div class="col-12 my-2">
                                    <div class="media-block">
                                        <div class="row media-block__first-row">
                                            <div class="col-12 media-block__top">
                                                <div class="row">
                                                    <div class="col-12 col-md-4 media-block__media-container">
                                                        <!-- desired width here is 140px -->
                                                        <img src="https://via.placeholder.com/180/440066/eeeeee" alt="placeholder image">
                                                    </div>

                                                    <div class="col-12 col-md-8 media-block__rich-container">
                                                        <p>Sed quam, esse in delectus consequatur, ullam enim ipsa sunt corrupti odio, ducimus facilis amet ea eveniet voluptates fuga corporis nemo totam perspiciatis unde tempora! Distinctio vero ad sapiente placeat.</p>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>

                            <div class="row">
                                <div class="col-12 my-2">
                                    <div class="media-block">
                                        <div class="row media-block__first-row">
                                            <div class="col-12 media-block__top">
                                                <div class="row">
                                                    <div class="col-12 col-md-4 media-block__media-container">
                                                        <!-- desired width here is 140px -->
                                                        <img src="https://via.placeholder.com/180/440066/eeeeee" alt="placeholder image">
                                                    </div>

                                                    <div class="col-12 col-md-8 media-block__rich-container">
                                                        <p>Iusto inventore, id possimus iste modi nihil provident ullam adipisci minus sequi architecto consectetur commodi dignissimos, molestiae distinctio quibusdam ipsum reiciendis vel accusamus ipsam cum alias, dolores minima veritatis. Ratione!</p>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>

                    <div class="col-12 col-lg-4 mb-4">
                        <div class="phd-shadow-box">
                            <p>Ignore me, as I am only a placeholder to simulate the right-side-content.  I like lemon & strawberry cupcakes best.</p>
                            <p>Lorem ipsum, dolor sit amet consectetur adipisicing elit. Aspernatur reprehenderit eligendi inventore quos dignissimos labore cum ut voluptate aut qui distinctio, similique quibusdam! Unde, cumque a magni odio numquam fugiat.</p>
                            <p>Quia veniam, numquam fugiat consequuntur nobis voluptas blanditiis obcaecati architecto sapiente ipsa. Necessitatibus nisi ratione blanditiis laborum alias, doloremque, maiores ipsum non magnam sunt eum ut aliquid incidunt sapiente tempora!</p>

                        </div>
                    </div>
                </div>
                <!-- End:   Media Block - only required fields -->

                <!-- End:   PHD Media Block / Profile Card component -->
            </div>
        </div>
    </div>
</template>

<script>
    export default {
        data() {
            return {}
        }
    }
</script>


// WEBPACK FOOTER //
// demo/components/phd/phd-media-block.vue